// extracted by mini-css-extract-plugin
export default {"icon":"MechanicIcon_icon__QreKb","bubble":"MechanicIcon_bubble__p7rlJ","glow":"MechanicIcon_glow__FQC9E","shadow":"MechanicIcon_shadow__ctN+2"};